/*       */

import { loadData, mutateData } from 'app/utils/redux/action-utils';
import OptionsBuilder from 'app/utils/api/OptionsBuilder';

import formDefinitionQuery from 'graphql/designer/formDefinitionQuery';
import designerFormListQuery from 'graphql/designer/designerFormListQuery';
import formDefinitionTypeaheadQuery from 'graphql/designer/formDefinitionTypeaheadQuery';
import formDefinitionVersionTypeaheadQuery from 'graphql/designer/formDefinitionVersionTypeaheadQuery';
import scriptVersionTypeaheadQuery from 'graphql/designer/scriptVersionTypeaheadQuery';
import createFormDefinitionMutation from 'graphql/designer/createFormDefinitionMutation';
import cloneFormDefinitionMutation from 'graphql/designer/cloneFormDefinitionMutation';
import deleteFormDefinitionMutation from 'graphql/designer/deleteFormDefinitionMutation';
import updateFormDefinitionMutation from 'graphql/designer/updateFormDefinitionMutation';
import publishFormDefinitionMutation from 'graphql/designer/publishFormDefinitionMutation';

export const LOAD_FORMS_DEFINITIONS_STARTED = '@@affectli/designer/LOAD_DESIGNER_FORMS_STARTED';
export const LOAD_FORMS_DEFINITIONS = '@@affectli/designer/LOAD_DESIGNER_FORMS';

export const LOAD_FORM_DEFINITION_STARTED = '@@affectli/designer/LOAD_FORM_DEFINITION_STARTED';
export const LOAD_FORM_DEFINITION = '@@affectli/designer/LOAD_FORM_DEFINITION';

export const CREATE_FORM_DEFINITION_STARTED = '@@affectli/designer/CREATE_FORM_DEFINITION_STARTED';
export const CREATE_FORM_DEFINITION = '@@affectli/designer/CREATE_FORM_DEFINITION';

export const UPDATE_FORM_DEFINITION_STARTED = '@@affectli/designer/UPDATE_FORM_DEFINITION_STARTED';
export const UPDATE_FORM_DEFINITION = '@@affectli/designer/UPDATE_FORM_DEFINITION';

export const CLONE_FORM_DEFINITION_STARTED = '@@affectli/designer/CLONE_FORM_DEFINITION_STARTED';
export const CLONE_FORM_DEFINITION = '@@affectli/designer/CLONE_FORM_DEFINITION';

export const DELETE_FORM_DEFINITION_STARTED = '@@affectli/designer/DELETE_FORM_DEFINITION_STARTED';
export const DELETE_FORM_DEFINITION = '@@affectli/designer/DELETE_FORM_DEFINITION';

export const LOAD_FORM_ACTION_DEFINITION_STARTED = '@@affectli/designer/LOAD_FORM_ACTION_DEFINITION_STARTED';
export const LOAD_FORM_ACTION_DEFINITION = '@@affectli/designer/LOAD_FORM_ACTION_DEFINITION';

export const LOAD_FORM_DEFINITION_TYPEAHEAD_STARTED = '@@affectli/designer/LOAD_FORM_DEFINITION_TYPEAHEAD_STARTED';
export const LOAD_FORM_DEFINITION_TYPEAHEAD = '@@affectli/designer/LOAD_FORM_DEFINITION_TYPEAHEAD';

export const LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD_STARTED = '@@affectli/designer/LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD_STARTED';
export const LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD = '@@affectli/designer/LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD';

/**
 * Loads the forms' definitions.
 */
export const loadDesignerForms = (options = {}) => {
    const variables = new OptionsBuilder(options).defaultStartStopIndexs(0, 30).build();
    return loadData(LOAD_FORMS_DEFINITIONS_STARTED, LOAD_FORMS_DEFINITIONS, designerFormListQuery)({ ...variables, startIndex: options.startIndex });
};

export const loadDesignerFormTypeahead = loadData(LOAD_FORM_DEFINITION_TYPEAHEAD_STARTED, LOAD_FORM_DEFINITION_TYPEAHEAD, formDefinitionTypeaheadQuery);

export const loadDesignerFormVersionTypeahead = formDefinitionId => {
    return loadData(
        LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD_STARTED,
        LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD,
        formDefinitionVersionTypeaheadQuery
    )({ filterBy: [{ field: 'primary.formDefinition', op: '=', value: formDefinitionId }] });
};

export const loadDesignerScriptVersionTypeahead = scriptId => {
    return loadData(
        LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD_STARTED,
        LOAD_FORM_DEFINITION_VERSION_TYPEAHEAD,
        scriptVersionTypeaheadQuery
    )({ filterBy: [{ field: 'primary.script', op: '=', value: scriptId }] });
};

/**
 * Loads the form definition with the given id.
 */
export const loadFormDefinition = id => loadData(LOAD_FORM_DEFINITION_STARTED, LOAD_FORM_DEFINITION, formDefinitionQuery)({ id });

/**
 * Loads the form definition for action openForm of Form Designer with the given id.
 */
export const loadActionFormDefinition = id => loadData(LOAD_FORM_ACTION_DEFINITION_STARTED, LOAD_FORM_ACTION_DEFINITION, formDefinitionQuery)({ id });

/**
 * Creates a new the form definition.
 */
export const createFormDefinition = record =>
    mutateData(CREATE_FORM_DEFINITION_STARTED, CREATE_FORM_DEFINITION, createFormDefinitionMutation, 'Form created successfully.')({ record });

/**
 * Updates a form definition.
 */
export const updateFormDefinition = record =>
    mutateData(UPDATE_FORM_DEFINITION_STARTED, UPDATE_FORM_DEFINITION, updateFormDefinitionMutation, 'Form updated successfully.')({ record });

export const publishFormDefinition = id =>
    mutateData(UPDATE_FORM_DEFINITION_STARTED, UPDATE_FORM_DEFINITION, publishFormDefinitionMutation, 'Form published successfully.')({ id });

/**
 * Creates a new the form definition.
 */
export const cloneFormDefinition = (id, name, description) =>
    mutateData(CLONE_FORM_DEFINITION_STARTED, CLONE_FORM_DEFINITION, cloneFormDefinitionMutation, 'Form duplicated successfully.')({ id, name, description });

/**
 * Creates a new the form definition.
 */
export const deleteFormDefinition = (id, record) =>
    mutateData(DELETE_FORM_DEFINITION_STARTED, DELETE_FORM_DEFINITION, deleteFormDefinitionMutation, 'Form deleted successfully.')({ id, record });
